import { ChangeEventHandler, FC } from 'react';

import clsx from 'clsx';
import useSWR from 'swr';

import { CreateSlotButton } from './createSlotButton/CreateSlotButton';
import { ResetMarksButton } from './resetMarksButton/ResetMarksButton';
import { SlotsTable } from './slotsTable/SlotsTable';
import { SyncSlotsButton } from './syncSlotsButton/SyncSlotsButton';

import css from './SlotsSettingsPage.module.css';

import { slotService } from 'v2/api/slotService';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { SearchTextField } from 'v2/components/searchTextField/SearchTextField';
import { useFilter } from 'v2/hooks/useFilter';
import { usePagination } from 'v2/hooks/usePagination';
import { SlotFilter } from 'v2/types/SlotModel';

export const SlotsSettingsPage: FC = () => {
  const pagination = usePagination({ defaultPageSize: 30 });

  const { filter, debouncedFilter, onChange } = useFilter<SlotFilter>({
    title: '',
    providerName: '',
  });

  const { data, mutate } = useSWR(
    ['getSlots', pagination.page, pagination.pageSize, debouncedFilter],
    slotService.getSlots,
    { keepPreviousData: true }
  );

  const handleChangeFilter =
    (field: keyof SlotFilter): ChangeEventHandler<HTMLInputElement> =>
    (e) => {
      onChange(field, e.target.value);
    };

  return (
    <PageLayout className={css.slotsSettings} overflow="hidden">
      <PageTitle
        action={
          <div className={clsx('form-group', css.slotsSettingsActions)}>
            <SyncSlotsButton onSuccess={mutate} />

            <CreateSlotButton onSuccess={mutate} />

            <ResetMarksButton onSuccess={mutate} />
          </div>
        }
      >
        Slots Settings
      </PageTitle>

      <div className={css.slotsSettingsPageContent}>
        <div className="form-group">
          <SearchTextField value={filter.title} onChange={handleChangeFilter('title')} label="Title" />

          <SearchTextField value={filter.providerName} onChange={handleChangeFilter('providerName')} label="Provider" />
        </div>

        <SlotsTable data={data} pagination={pagination} onRevalidate={mutate} />
      </div>
    </PageLayout>
  );
};
